<button
    class="btn disable__override"
    matTooltip="{{data}}"
    matTooltipClass="tooltip"
    [matTooltipHideDelay]="0"
    tabindex="-1"
>
    <mat-icon class="icon-display" aria-hidden="false" aria-label="Example home icon" fontIcon="info"></mat-icon>
</button>